import { getBasicData } from "@/api/baseData";
import { IS_AGREE, MESSAGE_NO_E39 } from "@/config";
import { useLoadingStore } from "@/stores/loading";
import { useUserStore } from "@/stores/user";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

interface Detail {
  id?: number;
  customer_number?: string;
  customer_type_id?: string;
  customer_group_type_id?: string;
  business_entity_type?: string;
  corporate_number?: string;
  group_name?: string;
  station_name?: string;
  department_name?: string;
  unit_name?: string;
  section_name?: string;
  position?: string;
  last_name?: string;
  first_name?: string;
  reading_last_name?: string;
  reading_first_name?: string;
  phone_number?: string;
  emergency_phone_number?: string;
  zipcode?: string;
  pref?: string;
  city?: string;
  house_number?: string;
  building_name?: string;
  email_address?: string;
  billing_post_type?: string;
  billing_post_group_name?: string;
  billing_post_department_name?: string;
  billing_post_last_name?: string;
  billing_post_first_name?: string;
  billing_post_phone_number?: string;
  billing_post_zipcode?: string;
  billing_post_pref?: string;
  billing_post_city?: string;
  billing_post_house_number?: string;
  billing_post_building_name?: string;
}
interface Info {
  id?: number;
  is_personal_information_handling?: string;
  login_id?: string;
  password?: string;
}

export default function BasicInfoDetail() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isAgree, setIsAgree] = useState<string | null>(null);

  const onClickEdit = () => {
    navigate("/basic_info/edit");
  };
  const setLoading = useLoadingStore((state) => state.setLoading);
  //const userId = Number(useParams().id);
  const user = useUserStore((state) => state.user);
  const [details, setDetails] = useState<Detail[]>([]);
  const [info, setInfo] = useState<Info[]>([]);

  useEffect(() => {
    setLoading(true);
    const response = getBasicData();
    response
      .then((result) => {
        setDetails(result.data.details);
        setInfo(result.data.info);
        setIsAgree(
          IS_AGREE[result.data.info[0]["is_personal_information_handling"]]
        );
        console.log(result.data);
      })
      .catch((error) => {
        setErrorMessage(MESSAGE_NO_E39);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <div className="sub-header">
        <ul className="uk-tab uk-margin">
          <li>
            <Link to="/drm_pf/api">利用料</Link>
          </li>
          <li className="uk-active">
            <Link to="/basic_info">基本情報</Link>
          </li>
          <li>
            <Link to="/drm_pf/info">DRM-PF</Link>
          </li>
          <li>
            <Link to="/ticket">DRM-Chat</Link>
          </li>
        </ul>
      </div>
      <div className="container uk-margin-large-bottom">
        <div className="uk-text-right attribute-tab">
          <button
            className="uk-button--m uk-button-refer uk-margin-left"
            onClick={onClickEdit}
          >
            編集
          </button>
        </div>

        <div className="info-tbl_wrap uk-margin-small-top">
          <table className="info-tbl uk-width-1-1">
            {details.map((item, index) => {
              return (
                <tbody key={item.id}>
                  <tr>
                    <th className="label">顧客番号</th>
                    <td className="content">{item.customer_number}</td>
                  </tr>
                  <tr>
                    <th className="label">道路管理者区分</th>
                    <td className="content">{item.customer_type_id}</td>
                  </tr>
                  <tr>
                    <th className="label">団体区分</th>
                    <td className="content">{item.customer_group_type_id}</td>
                  </tr>
                  <tr>
                    <th className="label">法人・団体名</th>
                    <td className="content">{item.group_name}</td>
                  </tr>
                  <tr>
                    <th className="label">局名</th>
                    <td className="content">{item.station_name}</td>
                  </tr>
                  <tr>
                    <th className="label">部署名・所属</th>
                    <td className="content">{item.department_name}</td>
                  </tr>
                  <tr>
                    <th className="label">課名</th>
                    <td className="content">{item.section_name}</td>
                  </tr>
                  <tr>
                    <th className="label">室名または係名</th>
                    <td className="content">{item.unit_name}</td>
                  </tr>
                  <tr>
                    <th className="label">役職</th>
                    <td className="content">{item.position}</td>
                  </tr>
                  <tr>
                    <th className="label">姓</th>
                    <td className="content">{item.last_name}</td>
                  </tr>
                  <tr>
                    <th className="label">名</th>
                    <td className="content">{item.first_name}</td>
                  </tr>
                  <tr>
                    <th className="label">せい</th>
                    <td className="content">{item.reading_last_name}</td>
                  </tr>
                  <tr>
                    <th className="label">めい</th>
                    <td className="content">{item.reading_first_name}</td>
                  </tr>
                  <tr>
                    <th className="label">電話番号</th>
                    <td className="content">{item.phone_number}</td>
                  </tr>
                  <tr>
                    <th className="label">緊急連絡先（携帯電話等）</th>
                    <td className="content">{item.emergency_phone_number}</td>
                  </tr>
                  <tr>
                    <th className="label">郵便番号</th>
                    <td className="content">{item.zipcode}</td>
                  </tr>
                  <tr>
                    <th className="label">都道府県</th>
                    <td className="content">{item.pref}</td>
                  </tr>
                  <tr>
                    <th className="label">市区町村</th>
                    <td className="content">{item.city}</td>
                  </tr>
                  <tr>
                    <th className="label">町名番地</th>
                    <td className="content">{item.house_number}</td>
                  </tr>
                  <tr>
                    <th className="label">建物名・部屋番号</th>
                    <td className="content">{item.building_name}</td>
                  </tr>
                  <tr>
                    <th className="label">メールアドレス</th>
                    <td className="content">{item.email_address}</td>
                  </tr>
                </tbody>
              );
            })}
          </table>
          <table className="info-tbl uk-width-1-1">
            {info.map((item, index) => {
              return (
                <tbody key={item.id}>
                  <tr>
                    <th className="label">個人情報取扱い</th>
                    <td className="content">{isAgree}</td>
                  </tr>
                  <tr>
                    <th className="label">ログインID</th>
                    <td className="content">{item.login_id}</td>
                  </tr>
                  <tr>
                    <th className="label">パスワード</th>
                    <td className="content">＊＊＊＊</td>
                  </tr>
                </tbody>
              );
            })}
          </table>
        </div>
      </div>
    </div>
  );
}

export const basic_info_items = [
  { label: "顧客番号", content: "000001" },
  { label: "道路管理者区分", content: "02:道路管理者以外" },
  { label: "団体区分", content: "04:企業" },
  { label: "事業体区分", content: "1:法人" },
  { label: "法人番号", content: "5012402007468" },
  { label: "法人・団体名", content: "株式会社XXXXXXXXXXX" },
  { label: "部署名・所属", content: "都市整備部" },
  { label: "室名または係名", content: "環境推進課" },
  { label: "課名", content: "企画係" },
  { label: "役職", content: "係長" },
  { label: "姓", content: "申込" },
  { label: "名", content: "太郎" },
  { label: "せい", content: "もうしこみ" },
  { label: "めい", content: "たろう" },
  { label: "電話番号", content: "300001111" },
  { label: "緊急連絡先（携帯電話等）", content: "09012345678" },
  { label: "郵便番号", content: "1000001" },
  { label: "都道府県", content: "東京都" },
  { label: "市区町村", content: "千代田区" },
  { label: "町名番地", content: "霞が関三丁目2番2号" },
  { label: "建物名・部屋番号", content: "西館" },
  { label: "メールアドレス", content: "xx_xx@drm.or.jp" },
  { label: "請求先", content: "2:申込者以外" },
  { label: "請求先 - 法人・団体名", content: "株式会社YYYYYYYYYY" },
  { label: "請求先 - 部署名・所属", content: "研究振興部" },
  { label: "請求先 - 姓", content: "課金" },
  { label: "請求先 - 名", content: "次郎" },
  { label: "請求先 - 電話番号", content: "0387654321" },
  { label: "請求先 - 郵便番号", content: "1000001" },
  { label: "請求先 - 都道府県", content: "東京都" },
  { label: "請求先 - 市区町村", content: "千代田区" },
  { label: "請求先 - 町名番地", content: "霞が関三丁目2番2号" },
  { label: "請求先 - 建物名・部屋番号", content: "南館" },
];

export const login_info_items = [
  { label: "個人情報取扱い", content: "1:同意する" },
  { label: "ログインid", content: "000001" },
  { label: "パスワード", content: "＊＊＊＊＊" },
];
